module.exports = __webpack_public_path__ + "img/aboutbtm.cfa53b9f.jpg";